import { Suspense, useMemo, useState } from 'react';
import { Badge, Button, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { Sidebar } from './Sidebar';
import { Outlet } from 'react-router-dom';
import { useTaskMonitor } from '../../hooks/useTaskMonitor';
import { useTaskStore } from '../../stores/useTaskStore';
import logo from '../../assets/logo.jpg';
import { SiteFooter } from './SiteFooter';
import { RuntimeNoticeCenter } from '../system/RuntimeNoticeCenter';

export function AppLayout() {
  useTaskMonitor();
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const tasks = useTaskStore((state) => state.tasks);
  const activeTaskCount = useMemo(
    () => tasks.filter((task) => ['pending', 'validating', 'running'].includes(task.status)).length,
    [tasks]
  );

  return (
    <div className="app-shell">
      <Sidebar />
      <header className="mobile-app-bar">
        <Button
          type="text"
          className="mobile-menu-button"
          icon={<MenuOutlined />}
          aria-label="打开主导航"
          onClick={() => setIsMobileNavOpen(true)}
        />
        <div className="mobile-brand">
          <img src={logo} alt="" />
          <strong>AI Fashion</strong>
        </div>
        <Badge
          count={activeTaskCount}
          overflowCount={99}
          className={`mobile-task-badge ${activeTaskCount === 0 ? 'is-empty' : ''}`}
        />
      </header>
      <main className="app-main">
        <RuntimeNoticeCenter />
        <div className="app-content">
          <Suspense fallback={<div role="status" aria-live="polite" className="page">正在加载页面…</div>}>
            <Outlet />
          </Suspense>
        </div>
        {window.CLOUD_RUNTIME && <SiteFooter />}
      </main>
      <Drawer
        placement="left"
        width={280}
        open={isMobileNavOpen}
        closable={false}
        onClose={() => setIsMobileNavOpen(false)}
        rootClassName="mobile-nav-drawer"
        styles={{ body: { padding: 0 } }}
      >
        <Sidebar variant="drawer" onNavigate={() => setIsMobileNavOpen(false)} />
      </Drawer>
    </div>
  );
}
